import { ChevronDown } from "lucide-react";
import {
  Button,
  Checkbox,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "web-design-system";
import { HOLDING_COLUMNS, HoldingColumnKey } from "./holding-columns";

const GROUP_LABEL = { visible: "Visible fields", general: "General" };

export function EditColumnsMenu({
  visible,
  onChange,
}: {
  visible: HoldingColumnKey[];
  onChange: (visible: HoldingColumnKey[]) => void;
}) {
  const toggle = (key: HoldingColumnKey, checked: boolean) =>
    onChange(checked ? [...visible, key] : visible.filter((k) => k !== key));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline">
          Edit column
          <ChevronDown />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="flex w-62 flex-col gap-4 p-4">
        {(["visible", "general"] as const).map((group) => (
          <div key={group} className="flex flex-col gap-3">
            <span className="text-xs text-muted-foreground">
              {GROUP_LABEL[group]}
            </span>
            {HOLDING_COLUMNS.filter((c) => c.group === group).map((column) => (
              <label
                key={column.key}
                className="flex cursor-pointer items-center gap-3 text-sm"
              >
                <Checkbox
                  checked={visible.includes(column.key)}
                  onCheckedChange={(checked) =>
                    toggle(column.key, checked === true)
                  }
                />
                {column.label}
              </label>
            ))}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
